/* A crisp decorative frame without changing carousel sizing or scroll steps. */
(() => {
  const selector = '.template-article .section--featured-collection-or-products .card--product:not(.card--product-upsell)';
  const namespace = 'http://www.w3.org/2000/svg';
  let density = 0;
  let densityQuery;

  function updateDensity() {
    const next = Number.isFinite(window.devicePixelRatio) && window.devicePixelRatio > 0
      ? window.devicePixelRatio : 1;
    if (density === next) return;
    density = next;
    // A whole device-pixel stroke avoids different rounding on opposite edges.
    const stroke = Math.max(1, Math.floor(density)) / density;
    document.documentElement.style.setProperty('--nosht-article-frame-stroke', `${stroke}px`);
    if (densityQuery) densityQuery.removeEventListener('change', updateDensity);
    densityQuery = window.matchMedia(`(resolution: ${density}dppx)`);
    densityQuery.addEventListener('change', updateDensity);
  }

  function initialize(root) {
    root.querySelectorAll(selector).forEach((card) => {
      if (!card.querySelector(':scope > .nosht-article-product-frame')) {
        const frame = document.createElementNS(namespace, 'svg');
        frame.classList.add('nosht-article-product-frame');
        frame.setAttribute('aria-hidden', 'true');
        frame.setAttribute('focusable', 'false');
        const rectangle = document.createElementNS(namespace, 'rect');
        rectangle.setAttribute('shape-rendering', 'crispEdges');
        rectangle.setAttribute('vector-effect', 'non-scaling-stroke');
        frame.append(rectangle);
        card.append(frame);
      }
      card.classList.add('nosht-article-frame-ready');
    });
  }

  updateDensity();
  initialize(document);
  window.addEventListener('resize', updateDensity, { passive: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
